import { API } from "../../../utils";

export const getAgedDebtorsReportListApi = async (query, pagination) => {
  const { pageIndex, pageSize } = pagination;
  const res = await API.get(`client-account-aged-debtors?page=${pageIndex}&per_page=${pageSize}`, query);
  return res.data;
};


export const downloadAgedDebtorsReport = async (query) => {
  const res = await API.get(`client-account/download-aged-debtors`, {
    ...query,
    responseType: "blob"
  });
  return res;
};

export const sendAgedDebtorsReport = async (query) => {
  const res = await API.post(`client-account/send-aged-debtors`, query);
  return res.data;
}

